var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        // Placeholder
        showPlaceholderProductGrid: true,
        placeholderProductPerRow: 8,
        filterTreeMobileStyle: 'style2',
    }
};
var itemCount = 0;

// Declare Templates
var bcSfFilterTemplate = {
  'soldOutClass': 'sold-out',
  'newArrivalLabelHtml': '<div class="tag tag--new"><span class="tag__text body-2">'+ theme.strings.productLabels.newLabel + '</span></div>',
  'launchingSoonLabelHtml': '<div class="tag tag--launching-soon tag--no-buy"><span class="tag__text body-2">'+ theme.strings.productLabels.launchingSoonLabel + '</span></div>',
  'onlineExclusiveLabelHtml': '<div class="tag tag--online-exclusive"><span class="tag__text body-2">'+ theme.strings.productLabels.onlineExclusiveLabel + '</span></div>',
  'onlineOnlyLabelHtml': '<div class="tag tag--online-only"><span class="tag__text body-2">'+ theme.strings.productLabels.onlineOnlyLabel + '</span></div>',
  'saleClass': 'on-sale',
  'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
  'wishListSVG': '<svg viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Desktop/Navigation/Left-logo" transform="translate(-1442.000000, -50.000000)" stroke="#ffffff" stroke-width="3"><g id="ic_heart" transform="translate(1442.000000, 48.000000)"><path d="M19.2842712,13.3914451 L11,22 L2.71572875,13.3914451 C0.428090416,11.0142582 0.428090416,7.16007691 2.71572875,4.78289011 C5.00336709,2.4057033 8.71236166,2.4057033 11,4.78289011 C13.2876383,2.4057033 16.9966329,2.4057033 19.2842712,4.78289011 C21.5719096,7.16007691 21.5719096,11.0142582 19.2842712,13.3914451 Z" id="Combined-Shape"></path></g></g></g></svg>',
  'wishListAdded': '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"><style type="text/css">	.st0{fill:#ffffff;stroke:#ffffff;stroke-width:3;stroke-linecap:round;}</style><g id="Symbols">	<g id="Desktop_x2F_Navigation_x2F_Left-logo" transform="translate(-1442.000000, -50.000000)">		<g id="ic_heart" transform="translate(1442.000000, 48.000000)">			<path id="Combined-Shape" class="st0" d="M19.3,13.4L11,22l-8.3-8.6c-2.3-2.4-2.3-6.2,0-8.6s6-2.4,8.3,0c2.3-2.4,6-2.4,8.3,0				S21.6,11,19.3,13.4z"/>		</g>	</g></g></svg>',
  'iWishSaveText': 'save text',
  'vendorHtml': '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  'productGridItemHtml': '<div class="card-grid__item" js-product-card>' +
                            '<div class="product-card is-loading">' +
                              '{{wishlist}}' +
                              '<div class="product-card__link-wrapper">' +
                                '<div class="product-card__swiper swiper" js-product-card="swiper" js-carousel="container" data-variant="{{itemVariantId}}" data-product="{{itemId}}">' +
                                  '<div class="swiper-wrapper">' +
                                    '<div class="product-card__thumbnail-container swiper-slide" js-product-card="slide" js-carousel="cell">' +
                                      '<a class="product-card__link" href="{{itemUrl}}" data-cy="productCard" data-product-impression {{dataLayerData}}>' +
                                        '{{itemImages}}' +
                                      '</a>' +
                                    '</div>' +

                                    '{{itemCarouselImages}}' +
                                  '</div>' +

                                  '{{carouselControls}}' +
                                '</div>' +

                                '<div class="card__tags">' +
                                  '{{itemTagLabels}}' +
                                '</div>' +

                                '<div class="product-card__secondary-ctas {{productType}}">' +
                                  '{{quickView}}' +
                                '</div>' +
                              '</div>' +

                              '<div class="product-card__footer-wrapper">' +
                                '<a class="product-card__footer" href="{{itemUrl}}" {{dataLayerData}}>' +
                                  '{{itemPromoBadge}}' +

                                  '<div class="product-card__footer-inner">' +
                                    '<span class="product-card__title body-1">{{itemTitle}}</span>' +
                                    '{{itemPrice}}' +
                                  '</div>' +
                                '</a>' +

                              '</div>' +
                              '<div class="product-card__swatches" js-product-card="swatchesContainer" data-product-url="/products/{{itemHandle}}"></div>' +

                              '<script type="application/json" data-id="ProductJson-{{itemId}}">{{productJson}}</script>' +
                            '</div>' +
                          '</div>',

  // Pagination Template
  'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
  'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
  'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
  'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
  'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  'sortingHtml': '<label class="bc-sf-filter-toolbar-item-label" tabindex="0"><svg width="16" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 10.8182H2.5V14H1.25V10.8182H0V8.90909H3.75V10.8182ZM2.5 0H1.25V7.63636H2.5V0ZM9.375 4.45455H5.625V6.36364H6.875V14H8.125V6.36364H9.375V4.45455ZM8.125 0H6.875V3.18182H8.125V0ZM15 8.90909H11.25V10.8182H12.5V14H13.75V10.8182H15V8.90909ZM13.75 0H12.5V7.63636H13.75V0Z" fill="white"/></svg><span>' + bcSfFilterConfig.label.sorting + '</span></label><ul class="bc-sf-filter-filter-dropdown">{{sortingItems}}</ul>',
};

/**
 * Check variant availability against tags selected.
 * @param {Object} data - individual product data.
 */
function checkVariantAvailability(data) {
  var tags = document.querySelectorAll('.bc-sf-filter-option-label.selected-type');
  var variants = data.variants;

  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];

    for (var x = 0; x < variants.length; x++) {
      var variant = variants[x];
      var mergedOptions = variant.merged_options[0].toUpperCase();

      const tagName = tag.innerText.toUpperCase();

      if (mergedOptions.indexOf(tagName) > -1) {
        return variant.available;
      }
    }
  }
}

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Check a product is out of stock
  if (window.location.search.indexOf('opt_size') > -1) {
    soldOut = !checkVariantAvailability(data);

  } else {
    soldOut = !data.available;
  }

  // Displaying price base on the policy of Shopify, have to multiple by 100
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}

/**
 * Build HTML for a single in-grid banner
 * @param {Object} content - Banner content data
 * @param {String} image - Banner image URL
 * @return {String} - Banner HTML
 */
function getInGridItemHtml(content, image, index) {
  if (!content) {
    return ''
  }

  const contentCenterClass = content.content_center || !image
    ? 'center'
    : ''

  const hasImageClass = image ? 'has-image' : ''

  const columnClass = (content.column_count === 2 || content.column_count === '2')
    ? 'two-column'
    : ''

  // Generate a unique identifier for the banner
  const uniqueId = 'in-grid-' + Math.random().toString(36).substring(2, 10);

  let imageTemplate = ''

  if (image) {
    const imageObject = {
      alt: content.title,
      aspect_ratio: 1,
      url: image,
    }

    imageTemplate = Frame.ResponsiveImageTemplate({
      image: imageObject,
      fill: true,
      lazyload: index > 8,
      sizes: '(min-width: 1024px) 308px, (min-width: 786px) 34vw, 50vw',
      widths: [150, 200, 250, 308, 350, 400],
    })

    imageTemplate += '<div class="in-grid-content__overlay"></div>'
  }

  return `
    <div
      id="${uniqueId}"
      class="in-grid-content ${columnClass}"
      style="
        background-color: ${content.background_color || 'transparent'};
        color: ${content.text_color};
      "
    >
      ${imageTemplate}

      <div class="in-grid-content__content ${hasImageClass} ${contentCenterClass}">
        ${content.title
          ? `<h1 class="in-grid-content__title">${content.title}</h1>`
          : ''
        }

        ${content.description
          ? `<p class="in-grid-content__description">${content.description}</p>`
          : ''
        }

        ${(content.button_text && content.button_url)
          ? `<a class="button button--primary button--primary color-light" href="${content.button_url}">
            ${content.button_text}
          </a>`
          : ''
        }
      </div>
    </div>
  `;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  itemCount++;
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  var inGridContent = bcSfFilterConfig.custom.in_grid_content;
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Product Type class
  itemHtml = itemHtml.replace(/{{productType}}/g, getProductType(data, false));
  // Add Quick View Icon
  itemHtml = itemHtml.replace(/{{quickView}}/g, buildQuickView(data));
  // Add wishlist Icon
  itemHtml = itemHtml.replace(/{{wishlist}}/g, buildWishlist(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add LIMITED Label
  itemHtml = itemHtml.replace(/{{itemPromoBadge}}/g, buildPromoLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data, itemCount));
  // Add Carousel Images
  itemHtml = itemHtml.replace(/{{itemCarouselImages}}/g, buildCarouselImages(data));
  // Add Carousel Controls
  itemHtml = itemHtml.replace(/{{carouselControls}}/g, buildCarouselControls(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  // Add Data Layer data tags.
  var dataLayerHTML = 'data-category="' + data.product_type + '" ' +
  'data-id="' + data.handle + '" ' +
  'data-list="' + document.title.replace(' - Newbie Store', '').replace(' â€“ Newbie', '') + '" ' +
  'data-name="' + data.title + '" ' +
  'data-position="' + (index + 1) + '" ' +
  'data-price="' + data.price_min + '" ' +
  'data-product-impression ' +
  'data-variant="' + data.variants[0].title + '" ' +
  'data-variant-sku="' + data.variants[0].sku + '" ' +
  'js-datalayer="productLink"';
  itemHtml = itemHtml.replace(/{{dataLayerData}}/g, dataLayerHTML);

  // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  if (soldOut === true && !(data.tags || []).includes("badge: coming soon - primary")){
    itemHtml = ``;
  }

  // Handle single in-grid content
  if (inGridContent && inGridContent.position === itemCount) {
    const inGridImage = bcSfFilterConfig.custom.in_grid_image;
    itemHtml += getInGridItemHtml(inGridContent, inGridImage, itemCount);
  }

  // Handle multiple in-grid contents
  const inGridContentsNew = bcSfFilterConfig.custom.multiple_in_grid_content || [];

  if (Array.isArray(inGridContentsNew) && inGridContentsNew.length) {
    const bannersForCurrentPosition = inGridContentsNew.filter((banner) => {
      const bannerPosition = typeof banner.position === 'string'
        ? parseInt(banner.position)
        : banner.position;

      return banner && bannerPosition === itemCount;
    });

    if (bannersForCurrentPosition.length) {
      bannersForCurrentPosition.forEach((banner) => {
        let bannerImage = null;

        if (typeof banner.image === 'string' && banner.image.trim() !== '') {
          bannerImage = banner.image;
        }

        const processedBanner = {
          ...banner,
          content_center: banner.content_center === 'true' || banner.content_center === true
        };

        itemHtml += getInGridItemHtml(processedBanner, bannerImage, itemCount);
      })
    }
  }

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add LIMITED Label
  itemHtml = itemHtml.replace(/{{itemPromoBadge}}/g, buildPromoLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data, index) {
  if (!images.length) {
    return '';
  }

  var html = '';

  const lazyload = typeof index === 'number' && index < 8 ? false : true

  const imageObject = {
    alt: data.title,
    aspect_ratio: 0.66,
    url: images[0].src,
  };

  const swapImageObject = {
    ...imageObject,
    url: images.length > 1 ? images[1].src : images[0].src,
  }

  html += Frame.ResponsiveImageTemplate({
    className: 'product-card__thumbnail product-card__thumbnail--primary',
    image: imageObject,
    fill: true,
    lazyload,
    sizes: '(min-width: 1024px) 308px, (min-width: 786px) 34vw, 50vw',
    widths: [150, 200, 250, 308, 350, 400],
  })

  html += Frame.ResponsiveImageTemplate({
    className: 'product-card__thumbnail product-card__thumbnail--secondary',
    image: swapImageObject,
    fill: true,
    lazyload: true,
    sizes: '(min-width: 1024px) 308px, (min-width: 786px) 34vw, 50vw',
    widths: [150, 200, 250, 308, 350, 400],
  })

  return html;
}

function buildCarouselImages(data) {
  if (!data.images.length) {
    return '';
  }

  return images
    .map((image) => {
      const imageObject = {
        alt: data.title,
        aspect_ratio: 0.66,
        url: image.src,
      }

      const imageTemplate = Frame.ResponsiveImageTemplate({
        className: 'product-card__thumbnail--slides',
        image: imageObject,
        fill: true,
        lazyload: true,
        sizes: '(min-width: 1024px) 308px, (min-width: 786px) 34vw, 50vw',
        widths: [150, 200, 250, 308, 350, 400],
      })

      return `
        <div
          class="product-card__thumbnail-container swiper-slide"
          js-product-card="slide"
          js-carousel="cell"
        >
          <a
            class="product-card__link"
            href="${data.url}"
            data-cy="productCard"
            data-product-impression
          >
            ${imageTemplate}
          </a>
        </div>
      `
    })
    .join('')
}

function removeLoadingClass(img) {
  const parent = img.closest('.product-card.is-loading');
  if (parent) {
    parent.classList.remove('is-loading');
  }
}

function buildCarouselControls(data) {
  var html = '';

  if (data.images.length <= 1) {
    return html;
  }

  html += '<div class="product-card__navigation product-card__navigation-prev swiper-button-prev swiper-button-custom" js-product-card="prev">' +
            '<svg class="icon icon__arrow icon__arrow--left" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>' +
            '</svg>' +
          '</div>' +

          '<div class="product-card__navigation-next product-card__navigation swiper-button-next swiper-button-custom" js-product-card="next"> ' +
            '<svg class="icon icon__arrow icon__arrow--right" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>' +
            '</svg>' +
          '</div>' +

          '<div class="product-card__pagination swiper-pagination" js-product-card="pagination"></div>'

  return html;
}

function imageParameters(url, parameters) {
  if (url === null) {
    return '';
  }

  var filePath = url.split('?');

  /**
   * Find out old URLs format and version
   */
  var original = {
    version: filePath[1],
  };

  if (url.indexOf('.jpg') > -1) {
    original.filetype = 'jpg';
  } else if (url.indexOf('.jpeg') > -1) {
    original.filetype = 'jpeg';
  } else {
    original.filetype = 'png';
  }

  /**
   * Use regex to test to see if the URL already has a size (matching 123x, x123, 123x123, master, original, large, medium, small)
   * If it does remove it
   */
  var formattedUrl = filePath[0].replace('.' + original.filetype, '').split('_');
  var urlParameters = formattedUrl[formattedUrl.length - 1];
  var regex = /^(master|original|large|medium|small)|([0-9]+[xX][0-9]+)|([0-9]+[xX])|([xX][0-9]+)$/;

  if (regex.test(urlParameters)) {
    filePath = filePath[0].replace('_' + urlParameters + '.' + original.filetype, '');
  } else {
    filePath = filePath[0].replace('.' + original.filetype, '');
  }

  /**
   * Set new URL parameters
   */
  var output = {};
  output.size = '_' + parameters.size;
  output.crop = parameters.crop ? '_crop_' + parameters.crop : '';
  output.version = original.version ? '?' + original.version : '';

  if (parameters.format === 'pjpg') {
    if (original.filetype === 'png') {
      output.filetype = '.progressive.png.jpg';
    } else {
      output.filetype = '.progressive.jpg';
    }
  } else if (parameters.format === 'jpg') {
    if (original.filetype === 'png') {
      output.filetype = '.png.jpg';
    } else {
      output.filetype = '.jpg';
    }
  } else {
    output.filetype = '.' + original.filetype;
  }

  var completeUrl = '' + filePath + output.size + output.crop + output.filetype + output.version;

  return completeUrl;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_price) {
    html = '<div class="product-price bc-sf-filter-product-item-price">';
    if (onSale) {
      html += '<s>' + bcsffilter.formatMoney(data.compare_at_price_min) + '</s> ';
      html += '<span class="bc-sf-filter-product-item-sale-price">' + bcsffilter.formatMoney(data.price_min) + '</span>';
    } else {
      if (priceVaries) {
        html += (bcSfFilterConfig.label_basic.from) + ' ';
      }
      html += '<span class="bc-sf-filter-product-item-regular-price">' + bcsffilter.formatMoney(data.price_min) + '</span>';
    }
    html += '</div>';
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }

  // Build Labels
  return soldOutLabel;
}

/**
 * Build a unique 'Limited Edition' badge for products that need it.
 * @return {String} - HTML structure for badge.
 */
function buildPromoLabels(data) {
  if (data.tags.indexOf('limited-edition-badge') > 1) {
    return '<div class="product-card__footer-badge">' +
              theme.product.limitedBadge +
            '</div>'
  }

  if (data.tags.find(tag => tag.toLowerCase().includes('extended size'))) {
    return '<div class="product-card__footer-badge">' +
      theme.product.extendedSize +
      '</div>'
  }

  if (data.tags.find(tag => tag.toLowerCase().includes('extended-size'))) {
    return '<div class="product-card__footer-badge">' +
      theme.product.extendedSize +
      '</div>'
  }

  if (data.tags.indexOf('rescued-fabrics-badge') > 1) {
    return '<div class="product-card__footer-badge">' +
              theme.product.rescuedBadge +
            '</div>'
  }

  if (data.tags.find(tag => tag.includes('online exclusive'))) {
    return '<div class="product-card__footer-badge">' +
              theme.product.onlineExclusive +
            '</div>'
  }

  if (data.tags.find(tag => tag.toLowerCase().includes('100%-cotton') || tag.toLowerCase().includes('100% cotton'))) {
    return '<div class="product-card__footer-badge">' +
              theme.product.organicCotton +
            '</div>'
  }

  if (data.tags.find(tag => tag.toLowerCase().includes('95%-cotton') || tag.toLowerCase().includes('95% cotton'))) {
    return '<div class="product-card__footer-badge">' +
              theme.product.organicCotton +
            '</div>'
  }

  return ''
}

// BUILD LABEL PRODUCT WITH TAGS - Excluding Online Exclusive tag
function buildTagLabels(data) {
  let tagObject = {};
  let sortedObject = {};
  let tagsLabels = [];
  let presetHierarchy = ['VIP Exclusive', 'Coming Soon - Teaser', 'coming soon', 'new in', 'newbie-icons'];

  if (data.compare_at_price_max > data.price_max) {
    return `
      <div class="tag tag--sale">
        <div class="tag__text body-2">
          -${Math.round(((data.compare_at_price_max - data.price_max) * 100) / data.compare_at_price_max)}%
        </div>
      </div>
    `;
  }

  if (data.tags) {
    data.tags.forEach((element) => {
      if (element === 'vip') {
        tagObject['VIP Exclusive'] = 'primary';
      }

      if (element === 'Coming Soon - Teaser') {
        tagObject['Coming Soon - Teaser'] = 'teaser';

      } else if ((element.includes('badge: ')) && (!element.includes('online exclusive')) && (!element.includes('sale'))) {
        const tagLabel = element.replace('badge: ', '').split(' - ').shift();
        const tagColour = element.replace('badge: ', '').split(' - ').pop().toLowerCase();
        tagObject[tagLabel] = tagColour;
      }

      if (element.includes('newbie-icons')) {
        tagObject['newbie-icons'] = 'white'
      }
    });

    presetHierarchy.map(proprtyName => {
      sortedObject[proprtyName] = tagObject[proprtyName]
    })

    if (JSON.stringify(sortedObject) !== '{}') {
      const newObject = JSON.parse(JSON.stringify(sortedObject));
      Object.keys(newObject).forEach((tagLabel) => {
        const tagColour = newObject[tagLabel];
        tagsLabels.push(buildProductLabels(tagLabel, tagColour));
      });
    }
  }

  return tagsLabels.join('');
}

// BUILD PRODUCT TAG HTML
function buildProductLabels(label, colour) {
  if (label === 'newbie-icons') {
    label = 'Newbie Icon';
  } else if (label === 'Coming Soon - Teaser') {
    label = 'Coming Soon';
  } else if(label === 'VIP Exclusive') {
    label = 'VIP Exclusive'
  }
  return `
    <div class="tag tag--${colour}">
      <div class="tag__text body-2">
        ${label}
      </div>
    </div>
  `
}

// BUILD ONLINE EXCLUSIVE TAG HTML
function buildTagHtml(element) {
  const tagLabel = element.replace('badge: ', '').split(' - ').shift();
  const tagColour = element.replace('badge: ', '').split(' - ').pop().toLowerCase();

  return `
    <div class="tag tag--${tagColour}">
      <div class="tag__text body-2">
        ${tagLabel}
      </div>
    </div>
  `
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    paginationHtml = jQ.parseHTML(paginationHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var paramSort = this.queryParams.sort || '';
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if(paramSort == k) {
          activeClass = 'active';
        }
        sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      html = jQ.parseHTML(html);
      jQ('.bc-sf-filter-custom-sorting').html(html);
      if(jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
      }

      var labelSort = '';
      if(paramSort.length > 0) {
        var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
        labelSort = bcSfFilterConfig.label[labelHandle];
      } else {
        labelSort = bcSfFilterConfig.label.sorting;
      }

      jQ('.bc-sf-filter-custom-sorting label span span').text(labelSort);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  jQ('.bc-sf-filter-filter-dropdown a').click(function(e){
    e.preventDefault();
    jQ(_this.getSelector('products')).empty();
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
  });

  jQ(".bc-sf-filter-custom-sorting > label").click(function(){
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
      jQ('#bc-sf-filter-tree').hide();
    }
  });

  jQ(".bc-sf-filter-custom-sorting > label").keypress(function(event){
    if (event.keyCode == 13) {
      if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
        jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
        jQ('#bc-sf-filter-tree').hide();
      }
   }
  });

  jQ(this.getSelector('filterTreeMobileButton')).click(function(){
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
  });


  const dropdownDesktop = document.getElementById('bc-sf-filter-top-sorting');
  const dropdownMobile = document.getElementById('bc-sf-filter-top-sorting-mobile');
  const filterDropdown =
    [...document.querySelectorAll('.bc-sf-filter-block-title a')];
  let dropdown = dropdownDesktop;

  /**
   * Update dropdown selector based on window width.
   */
  function updateDropdown() {
    dropdown = window.innerWidth <= 786 ? dropdownMobile : dropdownDesktop;
  }

  updateDropdown();

  /**
   * Run resize event listener to update dropdown selector.
   */
  window.addEventListener('resize', () => {
    updateDropdown();
  });

  /**
   * Run click event listener to hide dropdown if click outside.
   */
  document.addEventListener('click', (event) => {
    if (!dropdown.contains(event.target)) {
      hideSortDropdown();
    }
  });

  /**
   * Run click event listener for filter dropdown.
   */
  filterDropdown.forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      hideSortDropdown();
    });
  });

  /**
   * Hide sort dropdown selector.
   */
  function hideSortDropdown() {
    dropdown.classList.remove('bc-sf-filter-sort-active');
    jQ('.bc-sf-filter-filter-dropdown').hide();
  }
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  itemHtml = jQ.parseHTML(itemHtml);
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      html = jQ.parseHTML(html);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    html = jQ.parseHTML(html);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/

/**
 * Build quick view button
 * @param {Object} data - Product data.
 */
function buildQuickView(data) {
  let comingSoon = data.tags.some(tag => tag.toLowerCase().includes('coming soon'));
  let isVipProduct = data.tags.some(tag => tag.toLowerCase().includes('vip'));
  let isVipCustomer = bcSfFilterConfig?.customer?.tags?.some(tag => tag.toLowerCase().includes('vip'));


    let comingSoonTeaser = data.tags.some(tag => tag === 'Coming Soon - Teaser');

  const quickViewProduct =
    '<a href="{{itemUrl}}" class="product-card__quick-view-product">'+ theme.strings.productLabels.quick_view + '</a>'
  ;

  const comingSoonTeaserButton =
    '<button class="product-card__button button button--quick-view button--disabled" disabled>' +
      '<span class="product-card__button-desktop">' +
        theme.strings.productLabels.coming_soon_teaser +
      '</span>' +
    '</button>';

  const vipButton =
    '<button class="product-card__button button button--quick-view button--vip-exclusive" disabled name="quickview" role="button" aria-label="VIP exclusive">' +
      '<span class="product-card__button-desktop">' +
        theme.strings.productLabels.vip_exclusive +
      '</span>' +
    '</button>';

  const quickViewButton =
    '<button class="product-card__button button button--quick-view product-card__quick-view" data-product-url="/products/{{itemHandle}}" aria-label="Quickview" js-quick-view="toggle" name="quickview">' +
      '<span class="product-card__button-desktop">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g clip-path="url(#clip0_4770_21148)">' +
            '<path d="M20.2125 6.93814C20.1788 6.40945 19.74 5.99326 19.2112 5.99326H4.94625C4.4175 5.99326 3.99 6.3982 3.945 6.91564L3 20.9201C3 20.9201 3 20.9651 3 20.9876C3 21.5388 3.45 21.9888 4.00125 21.9888C10.8525 21.9888 15.51 21.9888 17.985 21.9888H20.0663C20.6175 21.955 21.0337 21.4826 21 20.9314L20.2125 6.93814ZM4.53 20.4927L5.4075 7.48932H18.75L19.4812 20.4927H4.53Z" fill="#57555F"/>' +
            '<path d="M11.9999 3.2036C13.8674 3.2036 15.3974 4.4297 15.6224 6.0045H16.9949C16.7699 3.76603 14.6099 2 11.9999 2C9.38988 2 7.22988 3.75478 7.00488 6.0045H8.37738C8.60238 4.4297 10.1436 3.2036 11.9999 3.2036Z" fill="#57555F"/>' +
            '<path d="M12.4952 9.99774H11.5052V13.0011H8.50146V14.0022H11.5052V16.9944H12.4952V14.0022H15.499V13.0011H12.4952V9.99774Z" fill="#57555F"/>' +
          '</g>' +
          '<defs>' +
            '<clipPath id="clip0_4770_21148">' +
              '<rect width="18" height="20" fill="white" transform="translate(3 2)"/>' +
            '</clipPath>' +
          '</defs>' +
        '</svg>' +
        theme.strings.productLabels.quick_view_add +
      '</span>' +
      '<span class="product-card__button-mobile">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g clip-path="url(#clip0_4770_21148)">' +
            '<path d="M20.2125 6.93814C20.1788 6.40945 19.74 5.99326 19.2112 5.99326H4.94625C4.4175 5.99326 3.99 6.3982 3.945 6.91564L3 20.9201C3 20.9201 3 20.9651 3 20.9876C3 21.5388 3.45 21.9888 4.00125 21.9888C10.8525 21.9888 15.51 21.9888 17.985 21.9888H20.0663C20.6175 21.955 21.0337 21.4826 21 20.9314L20.2125 6.93814ZM4.53 20.4927L5.4075 7.48932H18.75L19.4812 20.4927H4.53Z" fill="#57555F"/>' +
            '<path d="M11.9999 3.2036C13.8674 3.2036 15.3974 4.4297 15.6224 6.0045H16.9949C16.7699 3.76603 14.6099 2 11.9999 2C9.38988 2 7.22988 3.75478 7.00488 6.0045H8.37738C8.60238 4.4297 10.1436 3.2036 11.9999 3.2036Z" fill="#57555F"/>' +
            '<path d="M12.4952 9.99774H11.5052V13.0011H8.50146V14.0022H11.5052V16.9944H12.4952V14.0022H15.499V13.0011H12.4952V9.99774Z" fill="#57555F"/>' +
          '</g>' +
          '<defs>' +
            '<clipPath id="clip0_4770_21148">' +
              '<rect width="18" height="20" fill="white" transform="translate(3 2)"/>' +
            '</clipPath>' +
          '</defs>' +
        '</svg>' +
      '</span>' +
    '</button>';

  if (comingSoonTeaser) {
    return comingSoonTeaserButton;

  } else {
    if (comingSoon) {
      return quickViewProduct;
    }

    if (!window.theme.features.quickview) {
      return '';
    }

    if (isVipProduct && !isVipCustomer) {
      return vipButton;
    }

    return quickViewButton;
  }
}

/**
 * Build wishlist button
 * @param {Object} data product object
 */
function buildWishlist(data) {
  const firstVariant = data['variants'][0];
  const variantId = firstVariant.id;

  const wishlistButton =
    '<a class="mycl iWishAddColl iwishcheck" href="#" data-variant="' + variantId + '" data-product="{{itemId}}" data-title="{{itemTitle}}" aria-label="Wishlist add">' +
      '<svg width="18px" height="16px" viewBox="0 0 18 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
          '<g transform="translate(1.000000, 1.000000)" fill-rule="nonzero" stroke="#56545E">' +
            '<path d="M11.75,0 C10.8817812,0 10.0857813,0.272690265 9.38415625,0.810513274 C8.7115,1.32612832 8.26365625,1.98285841 8,2.46040708 C7.73634375,1.98282743 7.2885,1.32612832 6.61584375,0.810513274 C5.91421875,0.272690265 5.11821875,0 4.25,0 C1.827125,0 0,1.96424336 0,4.5690177 C0,7.38307965 2.27946875,9.30842035 5.73028125,12.223115 C6.31628125,12.7181018 6.9805,13.2791549 7.670875,13.877531 C7.761875,13.9565133 7.87875,14 8,14 C8.12125,14 8.238125,13.9565133 8.329125,13.8775619 C9.0195625,13.2790929 9.68375,12.7180708 10.2700937,12.2228053 C13.7205313,9.30842035 16,7.38307965 16,4.5690177 C16,1.96424336 14.172875,0 11.75,0 Z" id="Path"></path>' +
          '</g>' +
        '</g>' +
      '</svg>' +
    '</a>';

  return wishlistButton;
}

/**
 * Identify appointment type product
 * @param {Object} data product object
 */
function getProductType(data) {
  let productTypeClass = '';
  const productType = data.product_type;

  if (productType === 'appointment') {
    productTypeClass = 'product-card__secondary-ctas--appointment'
  }

  return productTypeClass;
}

function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%').css('height', $(this).height());
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }
    /* end-initialize-bc-al */
  // Call theme init function
  // if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
  //   $(theme.init);
  // }
  // End For List View
};

/**
 * Update the Load More button text.
 * - Runs the original `buildLoadMoreEvent` function, then replaces the product
 *   count text that displays.
 * - Fixes issue where the standard Boost code does not support additional
 *   elements in the product grid.
 * - Issue fixed by recreating the existing code from Boost but subtracting the
 *   promo card elements from the product count.
 */
var originalBuildLoadMoreEvent = BCSfFilter.prototype.buildLoadMoreEvent;
BCSfFilter.prototype.buildLoadMoreEvent = function(data, eventType) {
  // Call original method
  originalBuildLoadMoreEvent.call(this, data);
  // Replace product count text based to account for promo cards.
  var pageStart = this.queryParams.page === 1
    ? this.queryParams.page
    : (this.queryParams.page - 1) * this.queryParams.limit + 1;
  var toProduct = pageStart + data.products.length - 1;
  var fromProduct = (this.queryParams.page - 1) * this.queryParams.limit + 1;

  // Grab the number of product cards in the grid, and subtract the promo cards.
  var productElementsCount = jQ(this.getSelector("products") + " > *").length;
  var promoElementsCount = jQ(this.getSelector("products") + " > .promo").length;
  var productCardCount = productElementsCount - promoElementsCount;

  // Reduce the `fromProduct` number by the number of product cards on the page.
  // Accounts for having multiple pages loaded on the page with Load More mode.
  if (productElementsCount) {
    fromProduct -= productCardCount - this.queryParams.limit;
  }

  var updatedString = this.getSettingValue("label.loadMoreTotal")
    .replace(/{{ from }}/g, 1)
    .replace(/{{ to }}/g, toProduct)
    .replace(/{{ total }}/g, data.total_product);

  jQ("#bc-sf-filter-load-more-total")
    .empty()
    .html(updatedString);
}

productCount = 0;
productTotal = 0;
rowsTotal = 0;

// Datalayer variables
promotionPosition = 25;
pageTitle = document.title.replace(' - Newbie Store', '').replace(' â€“ Newbie', '');
loaded = false;

/**
 * Build additional elements.
 * - Function is called on every re-render
 * - A variety of scripts that run when the product grid is updated.
 * - e.g. Updates product count, Updates load more button, Handles promo cards,
 *   Handles wishlist clicks
 */
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  // get number of products loaded and add to data object
  if (eventType === 'sort' && this.queryParams.page != 1) {
    jQ(this.getSelector('products')).empty();
  }
  data.loaded_products = document.querySelectorAll('[js-product-card]').length;

  var currentPage = parseInt(this.queryParams.page);
  var paginationValue = this.getSettingValue('general.paginationType');

  var _this = this;
  var totalProduct = '<span>' + bcSfFilterConfig.label.showing_items_prefix + ' </span>' + data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = '<span>' + bcSfFilterConfig.label.showing_items_prefix + ' </span>' + data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  }
  totalProduct = jQ.parseHTML(totalProduct);
  jQ('#bc-sf-filter-total-product').html(totalProduct);

  const showResultsButton = jQ('#bc-sf-filter-mobile-footer button');
  const buttonText = showResultsButton.text();
  const totalProductText = '(' + data.total_product + ')';

  if (data.total_product > 0) {
    showResultsButton.html(totalProductText + ' ' + buttonText);
  } else {
    showResultsButton.html(buttonText);
  }

  matchHeightImage();
  jQ(window).resize(function() {
    resizeHandler(data);
    matchHeightImage();
  });

  jQ('body').find('.bc-sf-filter-skeleton-button').remove();

  // Prevent double tap on iOS
  this.isMobile()&&jQ(".bc-sf-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});

  // Fix image not loaded on mobile
  (this.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));

  // Make sure Frame is initialised before emitting event
  var checkForFrame = setInterval(function() {
    if (Frame.EventBus) {
      clearInterval(checkForFrame);

      if (eventType !== 'page')  {
        Frame.EventBus.emit('Boost:loaded');
      }
    }
  }, 250);

  // Reset datalayer impressions counter if filtering
  if (eventType === 'tag' | eventType === 'opt_size' | eventType === 'price' | eventType === 'product_type' | eventType === 'sort') {
    promotionPosition = 25;
    if(this.queryParams.page!==1){
    var currentPage = parseInt(this.queryParams.page) || 1;
    loadAllPagesToDatalayer.call(this, currentPage);
    }
  }

  /**
   * Load more status bar
   * ------------------------------------------------------------------------------
   * Status bar indicating the progress of total products shown
   *
   */
  var totalPages = Math.round(data.total_product / data.products.length);
  var currentPage = parseInt(this.queryParams.page);
  var progressBarWidth = currentPage * 100 / totalPages;

  if (data.event_type == 'init' && eventType!='sort' ) {
    jQ('#bc-sf-filter-load-more-button-container').append('<div class="bc-sf-filter-progress-bar"><div class="bc-sf-filter-progress-status"></div></div>');
    jQ('.bc-sf-filter-progress-status').css('width', `${progressBarWidth}%`);
  }

  jQ('.bc-sf-filter-progress-status').css('width', `${progressBarWidth}%`);

  if(data.products.length) {
    document.querySelector('#bc-sf-filter-load-more').classList.remove('visually-hidden');
  } else {
    document.querySelector('#bc-sf-filter-load-more').classList.add('visually-hidden');
  }

  productPositions();
  promoContainers();

  // Hide promo containers after the filters have been applied
  if (eventType === 'tag' | eventType === 'opt_size' | eventType === 'price' | eventType === 'product_type' | eventType === '') {
    disablePromoContainers();
  }

  /**
   * Handle resize function.
   */
  function resizeHandler() {
    const isMobile = window.matchMedia('(max-width:768px)').matches;
    const product_per_row_mobile = bcSfFilterConfig.custom.products_per_row_mobile;
    const product_per_row_desktop = bcSfFilterConfig.custom.products_per_row;
    const divisor = isMobile ? product_per_row_mobile : product_per_row_desktop;

    rowsTotal = Math.ceil(productTotal / divisor);
    _checkRows(rowsTotal, isMobile);
  }

  /**
   * Promo Containers
   * ------------------------------------------------------------------------------
   * Promo block inserts depending on a pagination type.
   *
   */
  function promoContainers() {
    var $collectionContainer = $('[js-collection-container]');
    var $promo = $('[js-collection-promo]');

    /**
     * Handle `default` pagination type.
     * - If `default` pagination type, then only certain amount products will
     *   load per page. This means the user only ever sees one page of products
     *   at a time.
     * - With this pagination type, we just need to add the promo blocks if their
     *   data-page attribute is equal to the current page.
     */
    if (paginationValue == 'default') {
      $promo.each(function() {
        var $this = $(this);
        var page_number = $this.data('page');
        var position_row = $this.data('row');

        if (page_number === currentPage) {
          if (position_row > 7) {
            var page_number_lowered = page_number - 1;
            var position_new_row = position_row - (page_number_lowered * 7);
            $this.css('grid-row-start', position_new_row.toString());
          }

          $this.attr('js-collection-promo', 'active');
        }
      });

    /**
     * Handle `load_more` pagination type.
     * - If `load_more` pagination type, then clicking the load more button will
     *   load in more products below the current page of products, so the user
     *   can see all the loaded products on one screen.
     * - With this pagination type, we add all promo blocks to the grid on
     *   initial load, but only display the ones based on how many pages are
     *   showing.
     * - On a `page` event, when the user clicks load more, we then just re-check
     *   which promo blocks to show.
     */
    } else if (paginationValue === 'load_more') {
      if (eventType === 'page') {

        // Update global `productTotal` variable
        productTotal = (productTotal + productCount);
        resizeHandler();

      } else {
        // Add all promo blocks to the grid on initial load

        $promo.clone().prependTo($collectionContainer);
        $('[js-collection-container] [js-collection-promo]').attr('js-collection-promo', 'active');

        // Update global `productCount` variable
        productCount = data.products.length;

        // Update global `productTotal` variable
        productTotal = productCount;
        resizeHandler();
      }
    }
  }

 /* jQ(".iWishAddColl.iwishcheck").on('click', function (e) {
    e.preventDefault();
    var iWishvId = jQ(this).attr("data-variant");
    iwish_addCollection(jQ(this), iWishvId);
    return false;
  });

  if (typeof iwishCheckColl === 'function') iwishCheckColl(); */

  jQuery("body").on("click",".iWishAddColl",function(evt) {
      //evt.preventDefault();
      evt.stopImmediatePropagation();
      var iWishvId = jQuery(this).attr("data-variant");
      var iWishpId = jQuery(this).attr("data-product");
      if(isInWishlist(iWishpId,iWishvId)){
        iwish_remove(jQuery(this), iWishvId, false);
        jQuery(this).html(iwish_add_txt_col);
      }
      else{
        iwish_addCollection(jQuery(this),iWishvId);
      }
      iWishCounter();
      return false;
    });

  if (eventType === 'page') {
    loadMoreDatalayer(data);
    buildSwatches();
  }

  if (eventType === 'init') {
    buildSwatches();
  }
};

function buildSwatches() {
  var swatches = [...document.querySelectorAll(
    '[js-product-card="swatchesContainer"]:not([js-product-card="swatchesLoaded"])'
  )];

  if (!swatches.length) {
    return;
  }

  var promises = [];

  for (var index = 0; index < swatches.length; index++) {
    var swatch = swatches[index];

    promises.push(
      fetch(swatch.dataset.productUrl + '?view=product-card-swatches')
    );
  }

  Promise.all(promises)
    .then((responseArr) => {
      return Promise.all(responseArr.map((response) => {
        if (!response.ok) {
          throw new Error('Network response was not OK');
        }

        return response.text()
      }))
    })
    .then((responseTexts) => {
      for (var index = 0; index < responseTexts.length; index++) {
        var response = responseTexts[index];

        swatches[index].innerHTML = response
        swatches[index].setAttribute('js-product-card', 'swatchesLoaded')
      }
      Frame.EventBus.emit('Boost:swatches-loaded');
    })
    .catch((error) => {
      throw new Error(error);
    });
}


// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/**
 * Check whether to show each promo card or not.
 * - Loop through all promo cards, check their `data-row` attribute and see if
 *   the row is less than the total number of rows.
 * - If it's less, show the product card. If it's more, hide the product card.
 * @param {Boolean} rowsTotal - Number of product grid rows.
 * @param {Boolean} isMobile - Mobile view value.
 */
function _checkRows(rowsTotal, isMobile) {
  $('[js-collection-promo="active"]').each(function () {
    const promoElement = $(this);
    const desktopRowNumber = parseInt(promoElement.attr('data-row-desktop'), 10);
    const mobileRowNumber = parseInt(promoElement.attr('data-row-mobile'), 10);

    const rowNumber = isMobile ? mobileRowNumber : desktopRowNumber;
    const shouldShow = rowsTotal >= rowNumber;

    promoElement.toggleClass('is-active', shouldShow);

    updateGridRowStyle(promoElement, isMobile);
  });
}

/**
 * Update row style for shop the look banners.
 * @param {Object} element - Banner object.
 * @param {Boolean} isMobile - Mobile view value.
 */
function updateGridRowStyle(element, isMobile) {
  const rowNumber = isMobile
    ? parseInt(element.attr('data-row-mobile'), 10)
    : parseInt(element.attr('data-row-desktop'), 10);
  let style = element.attr('style');
  const gridRowRegex = /(-ms-grid-row|grid-row)\s*:\s*\d*(\s*\/\s*span\s*\d+\s*;)/g;

  style = style.replace(gridRowRegex, (match, property, span) => {
    return `${property}: ${rowNumber}${span}`;
  });

  element.attr('style', style);
}

/**
 * Disable Promo Containers
 * ------------------------------------------------------------------------------
 * Go through and hide every promo container.
 *
 */
function disablePromoContainers() {
  $('[js-collection-promo="active"]').each(function() {
    var $this = $(this);
    if ($this.hasClass('is-active')) {
      $this.removeClass('is-active');
    }
  });
}

/**
 * Enable Promo Containers
 * ------------------------------------------------------------------------------
 * Go through and show every promo container.
 *
 */
function enablePromoContainers(data) {
  $('[js-collection-promo="active"]').each(function() {
    var $this = $(this);
    $this.addClass('is-active');
  });
}

/**
 * Pushes products to datalayer on when loading more products.
 * @param {Object} data - Product data.
 */
function loadMoreDatalayer(data) {
  var impressions = [];

  data.products.forEach(function(product) {
    impressions.push(convertResponseData(product));
    promotionPosition++;
  });

  productImpression(impressions);
}
/**
 * load All the Sorted data from Initial to Current Page.
 * Taking the value of current page as paramter.
 */
function loadAllPagesToDatalayer(currentPage) {
  var allImpressions = [];
  var _this = this;

  // Loop through all pages from 1 to the current page
  for (var page = 1; page <= currentPage; page++) {
    // Update the queryParams to fetch data for the specific page
    this.queryParams.page = page;

    // Fetch data for the page
    this.getFilterData("page", function(data) {
      // Process the products for the current page
      data.products.forEach(function(product) {
        allImpressions.push(convertResponseData(product));
        promotionPosition++;
      });

      // Push the impressions to the data layer after processing all pages
      if (page === currentPage) {
        productImpression(allImpressions);
      }
    });
  }
}

/**
 * Convert Boost data into correct form.
 * @param {Object} product - Boost product data.
 */
function convertResponseData(product) {
  return {
    brand: 'Newbie',
    category: product.product_type,
    id: product.handle,
    list: pageTitle,
    name: product.title,
    position: promotionPosition,
    price: Number(product.price_min / 100),
    variant: product.variants[0].title,
    dimension14: product.variants[0].sku,
  }
}

/**
 * Push product impressions to the datalayer.
 * @param {Array} impressions - Array of product impressions.
 */
function productImpression(impressions) {
  var splitImpressions = impressions
    .map((_, index) => {
      return impressions.slice(index * 16, index * 16 + 16);
    })
    .filter((array) => array.length);

  splitImpressions.forEach((array) => {
    dataLayer.push({
      event: 'productImpressions',
      ecommerce: {
        currencyCode: theme.currency,
        array,
        boost: true,
      },
    });
  });
}

/**
 * Product position
 * ------------------------------------------------------------------------------
 * Go through and update product position number of each card.
 * Can't use index as it resets to 1 every time.
 * Can't increase a counter and reset because page is built before we can reset.
 *
 */
function productPositions() {
  var clickPosition = 1;

  $('[data-product-impression]').each(function() {
    var $this = $(this);

    $this.attr('data-position', clickPosition);
    clickPosition++;
  });
}

/**
 * Update show results button
 */
function updateShowResultsButton() {
  const showResultsButton = jQ('#bc-sf-filter-mobile-footer button');
  const loadedProducts = document.querySelector('#bc-sf-filter-total-product').textContent.split(' ')[0];
  if (showResultsButton) {
    const buttonText = showResultsButton.text();
    const totalProductText = '(' + loadedProducts + ')';
    if (loadedProducts > 0) {
      showResultsButton.text(totalProductText + ' ' + buttonText);
    } else {
      showResultsButton.text(buttonText);
    }
  }
}

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){
  if (this.isBadUrl()) {
    window.location.href = window.location.pathname;
    return;
  }

  // Fetch data for all pages from 1 to the current page
  var currentPage = parseInt(this.queryParams.page) || 1;
  for (var page = 1; page <= currentPage; page++) {
    this.queryParams.page = page;
    this.updateApiParams(false);
    this.getFilterData("init");
  }
}
BCSfFilter.prototype.isBadUrl=function(){
  try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

$(document).on('click', '#bc-sf-filter-tree-mobile-button', function() {
  updateShowResultsButton();
})

$(document).on('click', '#bc-sf-filter-mobile-footer button', function() {
  updateShowResultsButton();
})

$(document).on('click', '.bc-sf-filter-load-more-button', function() {
  setTimeout(() => {
    Frame.EventBus.emit('Boost:loaded-more');
  }, 2000);
})

$(document).on('click', '.bc-sf-filter-select-button', function() {
  Frame.EventBus.emit('Boost:filter-applied');
})

$(document).on('click', '.bc-sf-filter-clear', function() {
  Frame.EventBus.emit('Boost:filter-cleared');
})

$(document).on('click', '.bc-sf-filter-clear-all', function() {
  Frame.EventBus.emit('Boost:filter-cleared');
})
